import type { FC, ReactNode } from 'react'

import { ArrowUpRight, Mail, Phone } from 'lucide-react'
import ContactForm from '@/components/landing/contact-form'
import { contact, contactSection } from '@/constants/content'

const Contact: FC = (): ReactNode => {
    return (
        <section id='contact' className='relative overflow-x-clip bg-ink text-paper [--focus-ring:var(--paper)]'>
            <div className='shell grid gap-14 py-24 sm:py-32 lg:grid-cols-12 lg:gap-10 lg:py-40'>
                <div className='lg:col-span-5'>
                    <h2 className='font-heading text-[14vw] font-bold leading-[0.88] tracking-[-0.015em] wdth-78 sm:text-[10vw] lg:text-[5.8vw] 2xl:text-[5.5rem]'>
                        {contactSection.heading}
                    </h2>

                    <p className='mt-8 max-w-[30rem] text-lg leading-relaxed text-paper/80 sm:text-xl'>
                        {contactSection.intro}
                    </p>

                    <div className='mt-12 border-t border-paper/20 pt-8'>
                        <p className='eyebrow text-paper/70'>
                            {contactSection.talk}
                        </p>

                        <a
                            href={contact.phoneHref}
                            className='group mt-4 flex w-fit items-center gap-3 font-heading text-3xl font-extrabold tracking-[-0.02em] transition-colors hover:text-blaze sm:text-4xl'
                        >
                            <Phone aria-hidden='true' className='size-7 text-blaze transition-transform duration-300 ease-bounce group-hover:-rotate-12' />
                            {contactSection.call}
                        </a>

                        <a
                            href={contact.emailHref}
                            className='group mt-4 flex w-fit items-center gap-3 text-xl transition-colors hover:text-blaze sm:text-2xl'
                        >
                            <Mail aria-hidden='true' className='size-6 text-blaze' />
                            {contact.email}
                            <ArrowUpRight aria-hidden='true' className='size-5 opacity-0 transition-[opacity,translate] duration-300 group-hover:translate-x-0.5 group-hover:opacity-100' />
                        </a>
                    </div>
                </div>

                <div className='lg:col-span-7'>
                    <ContactForm />
                </div>
            </div>
        </section>
    )
}

export default Contact
